<app-upsell-card
  htmlTitle="<strong class='card-title'>Add Priority</strong> Processing"
  question="Would you like to add priority processing to your prescription request?"
  [slug]="slug"
>
  <div>
    <p class="mb-4">Standard physician review time is typically <strong>1-2 hours</strong>.</p>
    <p class="mb-4">
      Add priority processing and your prescription request will be placed at the top of the physician review queue.
      Most priority orders are sent to the pharmacy
      <strong>within 20-30 minutes</strong>.
    </p>
  </div>
</app-upsell-card>
